const root = (theme) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: theme.spacing(2),
});

const container = (theme) => ({
  width: '100%',
  maxWidth: theme.dimensions.md,
});

const content = () => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const title = (theme) => ({
  marginBottom: theme.spacing(3),
});

const subtitle = (theme) => ({
  fontSize: theme.typography.fontSize1Rem,
});


const wizardClasses = {
  root,
  container,
  content,
  title,
  subtitle,
};

export {
  wizardClasses,
};
